import Head from 'next/head';

export default function Maintenance({message}) {

  return (
    <>
      <Head>
        <title>BizCare</title>
      </Head>

      <div className='main'>
        <div className='parent'>
          <div className='child1'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              xmlnsXlink='http://www.w3.org/1999/xlink'
              width='495.769'
              height='481.322'
              viewBox='0 0 495.769 481.322'
            >
              <defs>
                <clipPath id='clip-path'>
                  <rect
                    id='Rectangle_727'
                    data-name='Rectangle 727'
                    width='111.194'
                    height='164.602'
                    fill='#fff'
                  ></rect>
                </clipPath>
              </defs>
              <g
                id='Group_11683'
                data-name='Group 11683'
                transform='translate(-191.527 -138.448)'
              >
                <path
                  id='Path_6168'
                  data-name='Path 6168'
                  d='M173.3,328.6c102.139,0,201.138-20.523,201.138-122.662S401.691,0,299.552,0,0,57,0,159.137,71.163,328.6,173.3,328.6Z'
                  transform='matrix(-0.839, -0.545, 0.545, -0.839, 508.325, 619.77)'
                  fill='#164396'
                  opacity='0.18'
                ></path>
                <g
                  id='Path_6169'
                  data-name='Path 6169'
                  transform='translate(575.539 592.535) rotate(-163)'
                  fill='none'
                  opacity='0.35'
                >
                  <path
                    d='M175,331.83c103.142,0,203.114-20.725,203.114-123.867S405.637,0,302.494,0,0,57.557,0,160.7,71.862,331.83,175,331.83Z'
                    stroke='none'
                  ></path>
                  <path
                    d='M 175.0040283203125 331.8302307128906 L 175.0040283203125 330.8302307128906 C 188.5350799560547 330.8301696777344 201.4142761230469 330.46337890625 213.2838287353516 329.7400207519531 C 226.3616333007812 328.9430236816406 238.7505187988281 327.6817321777344 250.1064300537109 325.9911804199219 C 262.3934326171875 324.1619567871094 273.9075317382812 321.7660827636719 284.3289184570312 318.8700256347656 C 295.4671325683594 315.7747192382812 305.7220153808594 312.00732421875 314.8086853027344 307.67236328125 C 324.4337158203125 303.0806274414062 333.0490112304688 297.7088623046875 340.4153747558594 291.7063598632812 C 344.2455139160156 288.5853576660156 347.8226318359375 285.2251281738281 351.04736328125 281.7190246582031 C 354.3521728515625 278.1258544921875 357.3824768066406 274.2755737304688 360.0540771484375 270.2751770019531 C 362.7900695800781 266.1782836914062 365.2289733886719 261.8055114746094 367.3029174804688 257.2784118652344 C 369.42578125 252.6445770263672 371.2275390625 247.7154693603516 372.6581115722656 242.6280212402344 C 374.12158203125 237.4236145019531 375.2386779785156 231.9040222167969 375.9783630371094 226.2225189208984 C 376.7345275878906 220.4146270751953 377.117919921875 214.2712707519531 377.117919921875 207.9632720947266 C 377.1179809570312 189.4547729492188 378.003662109375 170.8779754638672 378.8601684570312 152.9128265380859 C 380.1986389160156 124.8401718139648 381.4628295898438 98.32437133789062 379.2337341308594 75.41886901855469 C 378.0448913574219 63.20262145996094 375.9637145996094 53.0018196105957 372.8714294433594 44.23361968994141 C 371.2112121582031 39.52626800537109 369.2237854003906 35.17631912231445 366.9642333984375 31.30456924438477 C 364.6100769042969 27.2707691192627 361.8747863769531 23.60861968994141 358.8343811035156 20.41981887817383 C 355.8729248046875 17.31377029418945 352.5221252441406 14.55161952972412 348.8750610351562 12.21006965637207 C 345.1078796386719 9.791419982910156 340.8988342285156 7.740469455718994 336.3647766113281 6.114269733428955 C 331.6914672851562 4.438069343566895 326.5219116210938 3.158719539642334 320.9997253417969 2.311769485473633 C 315.3247680664062 1.441319584846497 309.0986328125 1.000019550323486 302.4942321777344 1.000019550323486 C 289.575439453125 1.000019550323486 275.2777709960938 1.897669553756714 259.9984130859375 3.668019533157349 C 244.4354705810547 5.471219539642334 228.2605743408203 8.134369850158691 211.9229736328125 11.58341979980469 C 176.7525329589844 19.00831985473633 142.5343322753906 29.7297191619873 112.9676742553711 42.58847045898438 C 96.81027984619141 49.61542129516602 82.03232574462891 57.28211975097656 69.04432678222656 65.37567138671875 C 55.17122650146484 74.02072143554688 43.19907760620117 83.24462127685547 33.46047592163086 92.79112243652344 C 11.92132663726807 113.9052658081055 1.000076293945312 136.7529144287109 1.000026226043701 160.6993255615234 C 0.9999762773513794 185.8807220458984 5.295876502990723 209.3920745849609 13.76842594146729 230.580322265625 C 22.00352668762207 251.1747131347656 34.03187561035156 269.2233276367188 49.51932525634766 284.2248229980469 C 57.16177749633789 291.6274719238281 65.67972564697266 298.2914733886719 74.83657836914062 304.0317687988281 C 84.02912902832031 309.7945251464844 94.00882720947266 314.7159118652344 104.4983749389648 318.659423828125 C 125.9804229736328 326.7354125976562 149.7019805908203 330.8302612304688 175.0040283203125 330.8302307128906 L 175.0040283203125 331.8302307128906 M 175.0040283203125 331.8302307128906 C 71.86172485351562 331.8303833007812 -0.0001737304701237008 263.8414306640625 2.626953209983185e-05 160.6993255615234 C 0.0001762695319484919 57.55717086791992 199.3519744873047 0.0001695800747256726 302.4942321777344 1.958007851499133e-05 C 405.6365356445312 -0.0001804199273465201 378.1181335449219 104.8211669921875 378.117919921875 207.9632720947266 C 378.1177673339844 311.1053771972656 278.146240234375 331.8299560546875 175.0040283203125 331.8302307128906 Z'
                    stroke='none'
                    fill='#fff'
                  ></path>
                </g>
                <g
                  id='Group_11667'
                  data-name='Group 11667'
                  transform='translate(407.06 309.212)'
                >
                  <g
                    id='Group_11674'
                    data-name='Group 11674'
                    transform='translate(0 0)'
                  >
                    <path
                      id='Path_6133'
                      data-name='Path 6133'
                      d='M159.69,102.23a26.234,26.234,0,0,1-1.108,3.353c-2.46,5.117-6.655,7.929-12.628,8.169-2.539.1-5.087.017-7.886.017.318.957.567,1.772.86,2.572.971,2.645,1.919,5.3,2.977,7.913a2.314,2.314,0,0,0,1.325,1.143c2.8.864,4.455,2.606,4.224,4.621-.243,2.122-2.449,3.862-5.219,4.1-.517.045-1.039.044-1.558.044q-25.338,0-50.675-.025a11.716,11.716,0,0,1-3.788-.625,3.933,3.933,0,0,1-.106-7.6,3,3,0,0,0,1.915-2.067c1.166-3.3,2.413-6.573,3.7-10.058H89.741q-37.421,0-74.843,0c-7.231,0-12.724-3.777-14.4-9.947a14.625,14.625,0,0,1-.475-3.79Q-.017,56.93.006,13.817C.009,5.76,5.988.023,14.513.018q65.331-.037,130.664,0c7.354,0,12.537,4.02,14.251,10.864a5.753,5.753,0,0,0,.262.68ZM4.094,27.435c-.025.485-.058.826-.058,1.167q0,35.8.005,71.6a11.256,11.256,0,0,0,.168,2.054c.719,3.841,4.4,7.792,10.771,7.768,25.515-.1,51.031-.05,76.546-.008a1.9,1.9,0,0,0,2.171-1.483q6.706-18.307,13.52-36.579c.728-1.963,1.05-2.171,3.282-2.173q4.288,0,8.575,0c2.419,0,2.7.193,3.493,2.328Q129.3,90.329,136,108.558a1.889,1.889,0,0,0,2.221,1.454c2.125-.1,4.26-.024,6.39-.03,7.005-.019,11.04-3.825,11.041-10.429q0-35.209,0-70.418v-1.7Zm151.563-3.95c0-3.312,0-6.457,0-9.6a15.947,15.947,0,0,0-.047-1.622c-.512-4.96-4.855-8.429-10.586-8.43q-47.464-.008-94.929,0-17.926,0-35.852.008c-5.19.011-9.507,3.213-10.017,7.954-.413,3.833-.084,7.738-.084,11.7ZM91.787,125.15H137.92c-.744-2.01-1.507-3.879-2.112-5.792-.3-.936-.778-1.187-1.763-1.178-4.827.046-9.656.021-14.484.021-7.943,0-15.886-.01-23.828.024-.525,0-1.376.217-1.518.549-.877,2.034-1.594,4.131-2.428,6.376M95.8,114.3h38.1c-.809-2.209-1.533-4.3-2.369-6.35a1.536,1.536,0,0,0-1.184-.621q-15.505-.051-31.011,0a1.509,1.509,0,0,0-1.155.649c-.841,2.05-1.573,4.14-2.379,6.32m34.084-10.852c-.851-2.322-1.6-4.455-2.442-6.553a1.4,1.4,0,0,0-1.08-.54q-11.516-.046-23.033-.005c-.345,0-.909.183-1,.414-.867,2.173-1.653,4.375-2.5,6.684Zm-26-11.019h21.916c-.819-2.241-1.558-4.375-2.408-6.469a1.539,1.539,0,0,0-1.181-.636q-7.394-.065-14.788,0a1.391,1.391,0,0,0-1.07.55c-.865,2.142-1.638,4.317-2.468,6.558m17.856-11c-.927-2.524-1.743-4.845-2.658-7.131a1.5,1.5,0,0,0-1.13-.68c-2.077-.067-4.158-.051-6.235-.012-.343.006-.895.2-.987.428-.951,2.409-1.828,4.844-2.77,7.395Zm21.478,48.517q-.012-.3-.025-.6a16.276,16.276,0,0,0-2.088-.268q-25.163-.045-50.326-.054a13.726,13.726,0,0,0-2.021.083,7.952,7.952,0,0,0-1.426.486l.073.393a11.545,11.545,0,0,0,1.938.327q25.943.028,51.886,0a10.825,10.825,0,0,0,1.99-.372'
                      transform='translate(0 0)'
                      fill='#164396'
                    ></path>
                    <path
                      id='Path_6142'
                      data-name='Path 6142'
                      d='M246.9,20.958a5.843,5.843,0,1,1-.082,11.669,5.989,5.989,0,0,1-6.135-5.8,5.978,5.978,0,0,1,6.217-5.866m2.09,5.848a2.148,2.148,0,0,0-4.28-.1,2.142,2.142,0,0,0,4.28.1'
                      transform='translate(-140.396 -12.689)'
                      fill='#164396'
                    ></path>
                    <path
                      id='Path_6143'
                      data-name='Path 6143'
                      d='M339.774,26.829a6.193,6.193,0,0,1-12.365-.079,6.018,6.018,0,0,1,6.315-5.789,5.958,5.958,0,0,1,6.051,5.867M335.73,27a2,2,0,0,0-1.948-2.215,2.125,2.125,0,0,0-2.348,1.873,2.162,2.162,0,0,0,4.3.342'
                      transform='translate(-190.988 -12.691)'
                      fill='#164396'
                    ></path>
                    <path
                      id='Path_6144'
                      data-name='Path 6144'
                      d='M290.22,20.961a5.843,5.843,0,1,1,.018,11.668,6.008,6.008,0,0,1-6.194-5.9,6,6,0,0,1,6.176-5.764m2.142,5.832a2.152,2.152,0,0,0-4.288-.072,2.146,2.146,0,0,0,4.288.072'
                      transform='translate(-165.692 -12.691)'
                      fill='#164396'
                    ></path>
                    <g
                      id='Group_11682'
                      data-name='Group 11682'
                      transform='translate(87.339 73.579)'
                    >
                      <path
                        id='Path_6136'
                        data-name='Path 6136'
                        d='M220.289,306.493c.833-2.245,1.55-4.342,2.427-6.376.143-.331.994-.546,1.518-.549,7.943-.034,15.886-.024,23.828-.024,4.828,0,9.656.025,14.484-.021.985-.009,1.468.242,1.763,1.178.605,1.914,1.368,3.782,2.112,5.792Z'
                        transform='translate(-215.841 -254.923)'
                        fill='#fdb934'
                      ></path>
                      <path
                        id='Path_6137'
                        data-name='Path 6137'
                        d='M229.926,278.961c.806-2.18,1.538-4.27,2.379-6.32a1.51,1.51,0,0,1,1.155-.649q15.5-.053,31.01,0a1.537,1.537,0,0,1,1.185.621c.836,2.05,1.56,4.141,2.369,6.35Z'
                        transform='translate(-221.463 -238.237)'
                        fill='#fdb934'
                      ></path>
                      <path
                        id='Path_6138'
                        data-name='Path 6138'
                        d='M269.643,251.272H239.581c.852-2.309,1.638-4.511,2.505-6.684.092-.23.656-.413,1-.414q11.516-.035,23.033.006a1.4,1.4,0,0,1,1.08.539c.843,2.1,1.591,4.231,2.443,6.553'
                        transform='translate(-227.095 -221.401)'
                        fill='#fdb934'
                      ></path>
                      <path
                        id='Path_6139'
                        data-name='Path 6139'
                        d='M249.34,223.314c.83-2.241,1.6-4.416,2.468-6.558a1.39,1.39,0,0,1,1.07-.55q7.394-.054,14.788,0a1.538,1.538,0,0,1,1.18.636c.85,2.094,1.589,4.228,2.408,6.469Z'
                        transform='translate(-232.787 -204.461)'
                        fill='#fdb934'
                      ></path>
                      <path
                        id='Path_6140'
                        data-name='Path 6140'
                        d='M272.9,194.339h-13.78c.943-2.55,1.819-4.986,2.77-7.395.092-.233.644-.422.987-.428,2.078-.039,4.159-.056,6.236.012a1.505,1.505,0,0,1,1.13.68c.915,2.286,1.732,4.607,2.658,7.131'
                        transform='translate(-238.494 -186.482)'
                        fill='#fdb934'
                      ></path>
                      <path
                        id='Path_6141'
                        data-name='Path 6141'
                        d='M265.5,327.952a10.824,10.824,0,0,1-1.99.372q-25.943.03-51.886,0a11.553,11.553,0,0,1-1.938-.327l-.073-.393a7.95,7.95,0,0,1,1.426-.486,13.72,13.72,0,0,1,2.021-.083q25.163.017,50.326.054a16.257,16.257,0,0,1,2.088.267q.012.3.025.6'
                        transform='translate(-209.613 -271.578)'
                        fill='#f7941e'
                      ></path>
                    </g>
                  </g>
                </g>
                <g
                  id='Group_11678'
                  data-name='Group 11678'
                  transform='translate(269.593 387.727)'
                >
                  <g
                    id='Group_11670'
                    data-name='Group 11670'
                    transform='translate(0 0)'
                  >
                    <g
                      id='Group_11669'
                      data-name='Group 11669'
                      clipPath='url(#clip-path)'
                    >
                      <path
                        id='Path_6152'
                        data-name='Path 6152'
                        d='M130.511,202.512c.331-.145.655-.309.994-.432a8.234,8.234,0,0,0,5.734-8.38c-.336-5.611-.885-11.211-1.372-16.813q-1.037-11.924-2.133-23.843a17.173,17.173,0,0,0-.733-3.761c-2.38-7.211-4.825-14.4-7.251-21.6-.5-1.473-1.508-2.022-2.884-1.223-4.108,2.387-8.121,1.85-12.29.131-8.441-3.48-16.934-6.835-25.425-10.193a7.659,7.659,0,0,1-4.915-5.289c-1.69-5.913-3.469-11.8-5.206-17.7a2.665,2.665,0,0,1-.081-1.421q1.477,2.651,2.953,5.3c2.155,3.882,4.323,7.757,6.455,11.652a7.763,7.763,0,0,0,4.114,3.622c8.489,3.365,16.955,6.786,25.443,10.151,3.89,1.542,7.751-.009,9.2-3.616,1.46-3.627-.255-7.4-4.15-8.968-7.428-3-14.883-5.927-22.293-8.966a4.361,4.361,0,0,1-2.013-1.826c-2.19-4.044-4.287-8.14-6.338-12.257a7.683,7.683,0,0,1-.672-2.739c-.111-1.331-.029-2.677-.028-4.016,0-5.879,2.219-8.393,7.867-9.064-.7-1.41-1.378-2.887-2.179-4.293a1.484,1.484,0,0,0-1.211-.616,18.477,18.477,0,0,0-4.173,1.006c-5.358,2.275-10.676,4.645-15.987,7.028-6.029,2.7-8.2,8.414-5.521,14.512q10.305,23.422,20.632,46.835a7.739,7.739,0,0,1,.657,2.607q.448,7.862.747,15.732a5.6,5.6,0,0,1-.5,2.452c-4.931,10.741-9.7,21.564-14.947,32.149-3.037,6.127-.875,12.112,5.521,13.834h3.209c3.658-1.156,5.563-3.89,7.083-7.264,5.1-11.309,10.43-22.51,15.53-33.817a13.338,13.338,0,0,0,1.12-5.715c-.266-8.35-.777-16.691-1.154-25.038a2.068,2.068,0,0,1,.553-1.587,18.527,18.527,0,0,1,2.946-1.315c.2.466.361.8.478,1.141q4.166,12.391,8.315,24.788a8.265,8.265,0,0,1,.375,1.883q1.667,19.2,3.306,38.409c.183,2.134.646,4.254,2.3,5.661a32.388,32.388,0,0,0,4.718,2.854Z'
                        transform='translate(-54.046 -37.909)'
                        fill='#fff'
                      ></path>
                      <path
                        id='Path_6153'
                        data-name='Path 6153'
                        d='M201.2,0a40.111,40.111,0,0,0-5.979,2.532,15.083,15.083,0,0,0-6.109,17.717A15.25,15.25,0,1,0,207.8.6c-.6-.179-1.19-.4-1.785-.6Z'
                        transform='translate(-188.271)'
                        fill='#fff'
                      ></path>
                      <path
                        id='Path_6154'
                        data-name='Path 6154'
                        d='M50.378,34.985c-1.064-.484-1.832-.856-2.619-1.186-2.505-1.051-2.508-1.044-2.508-3.836,0-5.2-.105-5.31-5.278-5.31-2.994,0-5.989-.009-8.983,0-2.417.011-3.312.89-3.36,3.259-.032,1.6.475,3.53-.242,4.716-.655,1.084-2.63,1.367-4.024,2a2.85,2.85,0,0,0-.784.52c-1.094-1.235-2.143-2.513-3.293-3.693-1.7-1.746-2.96-1.745-4.653-.064Q10.646,35.356,6.7,39.352c-1.506,1.527-1.481,2.89.013,4.453.074.077.15.152.225.229,1.077,1.113,2.923,2.153,3.038,3.359.148,1.552-1.09,3.238-1.755,4.924-1.7,0-3.351-.015-5,0-2.2.024-3.171.943-3.19,3.1-.032,3.643-.024,7.286,0,10.928a4.194,4.194,0,0,0,3.7,3.63c1.39.008,2.78.012,4.17.023a1.255,1.255,0,0,1,.308.081c.031.043.082.082.09.129.664,3.71,3.327,5.162,6.58,6.285,4.385,1.514,8.605,3.5,12.97,5.084,7.047,2.552,9.652,9.55,7.414,15.38a3.95,3.95,0,0,0-.1.647c2.631,0,5.224.108,7.8-.042a2.384,2.384,0,0,0,2.283-2.63c.018-1.818,0-3.636,0-5.447l5.221-2.205c.967,1.079,2.022,2.346,3.172,3.52,1.686,1.723,2.981,1.72,4.653.057q3.928-3.905,7.827-7.84c1.708-1.724,1.7-2.924,0-4.668a3.844,3.844,0,0,0-.571-.563c-2.579-1.711-3.133-3.761-1.427-6.507.541-.871.856-1.421,1.962-1.328a34.384,34.384,0,0,0,3.848.016c1.915-.056,2.907-.993,2.923-2.859q.052-6.026-.006-12.053a2.52,2.52,0,0,0-2.691-2.735c-.373-.021-.749-.009-1.123-.01-4.4-.007-4.423,0-5.982-4.111a1.773,1.773,0,0,1,.3-1.487c.94-1.092,2.036-2.049,3.028-3.1,1.336-1.415,1.366-2.7.015-4.085Q62.245,35.289,58,31.128c-1.368-1.342-2.683-1.32-4.068.053-1.248,1.237-2.406,2.565-3.559,3.8m3.551,26.089a17.491,17.491,0,1,1-17.6-17.442,17.509,17.509,0,0,1,17.6,17.442'
                        transform='translate(38.315 -14.084)'
                        fill='#fff'
                      ></path>
                      <path
                        id='Path_6155'
                        data-name='Path 6155'
                        d='M53.508,6.911C58.629,7.46,64.2,5.371,67.3,11.2c2.024-3.653-1.041-8.644-5.379-9.012a6.634,6.634,0,0,0-5.18,1.644c-1.031.916-2,1.9-3.23,3.079'
                        transform='translate(20.324 -1.233)'
                        fill='#fff'
                      ></path>
                    </g>
                  </g>
                </g>
                <g
                  id='Group_11680'
                  data-name='Group 11680'
                  transform='translate(426.485 360.732)'
                >
                  <g
                    id='Group_11681'
                    data-name='Group 11681'
                    transform='translate(0 0)'
                  >
                    <path
                      id='Path_6170'
                      data-name='Path 6170'
                      d='M186.788,14.9a2.7,2.7,0,0,1-1.264,1.685,7.654,7.654,0,0,1-1.659.473.725.725,0,0,0-.538.414,1.343,1.343,0,0,0,.161,1.7,2.54,2.54,0,0,1-.306,3.667c-.358.36-.709.73-1.09,1.064a2.5,2.5,0,0,1-2.918.295,2.677,2.677,0,0,1-.577-.386,1.07,1.07,0,0,0-1.358-.157,1.025,1.025,0,0,0-.648.846,5.583,5.583,0,0,1-.528,1.586,2.2,2.2,0,0,1-1.918,1.1c-.623.025-1.249.029-1.872,0a2.507,2.507,0,0,1-2.37-1.955,3.1,3.1,0,0,1-.107-.6,1.126,1.126,0,0,0-.783-1.036c-.583-.288-.914-.009-1.316.273a2.622,2.622,0,0,1-3.81-.33c-.349-.349-.708-.691-1.027-1.065a2.5,2.5,0,0,1-.265-2.885,2.19,2.19,0,0,1,.311-.471,1.167,1.167,0,0,0,.189-1.551.827.827,0,0,0-.695-.525,3.139,3.139,0,0,1-2.115-.892,2.414,2.414,0,0,1-.677-1.562c-.019-.609-.028-1.22-.008-1.829a2.529,2.529,0,0,1,2.058-2.469,2.85,2.85,0,0,1,.557-.1c.492-.01.714-.263.946-.7.317-.6.064-.956-.249-1.394a2.61,2.61,0,0,1,.315-3.776c.318-.319.628-.646.961-.947a2.536,2.536,0,0,1,3.172-.276,1.477,1.477,0,0,1,.286.2,1.174,1.174,0,0,0,1.614.194c.276-.163.462-.292.477-.634a4.472,4.472,0,0,1,.15-.811A2.545,2.545,0,0,1,172.37.011c.537-.015,1.074-.014,1.611,0A2.569,2.569,0,0,1,176.5,2.124a3.956,3.956,0,0,1,.1.6.924.924,0,0,0,.65.839,1.158,1.158,0,0,0,1.359-.167c1.479-1.083,2.637-.963,3.938.34.257.257.518.509.768.772a2.575,2.575,0,0,1,.3,3.381,1.184,1.184,0,0,1-.152.212,1.155,1.155,0,0,0-.178,1.576c.157.283.294.457.625.485a5.585,5.585,0,0,1,.9.166,2.523,2.523,0,0,1,1.88,1.811c.025.081.063.158.1.237Zm-6.341,7.387a2.549,2.549,0,0,0,.319-.224c.293-.281.571-.579.866-.858a.452.452,0,0,0,.054-.686c-.311-.42-.6-.857-.9-1.281a1.277,1.277,0,0,1-.109-1.39c.291-.63.56-1.271,0-1.923a1.324,1.324,0,0,1,1.136-.937c.5-.075,1-.18,1.5-.257a.431.431,0,0,0,.417-.5c-.01-.377-.022-.756,0-1.132a.521.521,0,0,0-.529-.636c-.488-.065-.97-.177-1.457-.25a1.266,1.266,0,0,1-1.063-.9c-.243-.65-.5-1.3-.8-1.924a1.3,1.3,0,0,1,.116-1.429c.307-.422.6-.858.9-1.281a.434.434,0,0,0-.057-.651c-.295-.28-.584-.566-.861-.863a.451.451,0,0,0-.685-.062c-.421.309-.856.6-1.28.9a1.278,1.278,0,0,1-1.39.113c-.643-.3-1.3-.562-1.964-.813a1.253,1.253,0,0,1-.878-1.032c-.083-.515-.183-1.028-.264-1.543a.474.474,0,0,0-.557-.466c-.391.018-.784.014-1.175,0a.449.449,0,0,0-.528.439c-.076.516-.177,1.029-.264,1.543a1.275,1.275,0,0,1-.868,1.046c-.675.259-1.348.527-2,.828a1.25,1.25,0,0,1-1.35-.109c-.437-.311-.882-.613-1.316-.928a.438.438,0,0,0-.652.059c-.281.293-.567.583-.863.861a.458.458,0,0,0-.065.688c.315.435.619.877.925,1.318a1.233,1.233,0,0,1,.109,1.313c-.3.657-.578,1.326-.834,2a1.267,1.267,0,0,1-1.074.886c-.5.075-1,.178-1.5.259-.3.049-.469.183-.456.516.016.406.011.813,0,1.219a.446.446,0,0,0,.437.528c.5.072,1,.179,1.5.257a1.31,1.31,0,0,1,1.107.913c.242.65.505,1.294.8,1.923a1.3,1.3,0,0,1-.121,1.429c-.307.422-.6.856-.9,1.28a.439.439,0,0,0,.06.652c.295.28.584.566.861.863a.455.455,0,0,0,.687.06c.41-.3.834-.579,1.244-.879a1.3,1.3,0,0,1,1.427-.136c.628.293,1.272.558,1.923.8a1.329,1.329,0,0,1,.935,1.139c.07.473.189.94.243,1.414.045.393.241.517.609.5a8.666,8.666,0,0,1,1.044,0,.516.516,0,0,0,.633-.528c.061-.488.175-.97.25-1.457a1.249,1.249,0,0,1,.862-1.045c.675-.26,1.345-.534,2-.833a1.26,1.26,0,0,1,1.352.117q.639.453,1.285.9a3.574,3.574,0,0,0,.363.191'
                      transform='translate(-142.174 0)'
                      fill='#fdb934'
                    ></path>
                    <path
                      id='Path_6171'
                      data-name='Path 6171'
                      d='M15.43,144.27a8.523,8.523,0,0,1-.983-.428,2.836,2.836,0,0,1-1.44-2.309,1.778,1.778,0,0,0-1.39-1.866,1.318,1.318,0,0,0-1.427.155,3.992,3.992,0,0,1-1.858.995,2.774,2.774,0,0,1-2.434-.64,21.679,21.679,0,0,1-1.731-1.715,2.846,2.846,0,0,1-.314-3.5c.277-.458.619-.877.9-1.333a.621.621,0,0,0,.04-.462,9,9,0,0,1-.364-.88,1.085,1.085,0,0,0-1.148-.92,4.954,4.954,0,0,1-1.394-.312,2.832,2.832,0,0,1-1.868-2.645c-.037-.666-.017-1.335-.009-2a2.974,2.974,0,0,1,2.575-3.033,6.106,6.106,0,0,1,.942-.157.775.775,0,0,0,.829-.7,1.053,1.053,0,0,1,.156-.4c.487-.652.271-1.173-.184-1.762a5.114,5.114,0,0,1-.839-1.642,2.5,2.5,0,0,1,.591-2.433,21.227,21.227,0,0,1,1.849-1.841,2.827,2.827,0,0,1,3.292-.285c.473.28.921.606,1.367.929a.5.5,0,0,0,.586.065,10.922,10.922,0,0,1,1.241-.52.548.548,0,0,0,.414-.529,11.554,11.554,0,0,1,.24-1.326,1.148,1.148,0,0,1,1.264-.887,1.13,1.13,0,0,1,.938,1.266c-.112.818-.268,1.631-.421,2.442a1.175,1.175,0,0,1-.818.881c-.886.353-1.771.712-2.645,1.1a1.246,1.246,0,0,1-1.314-.094l-1.64-1.148c-.627-.438-.835-.418-1.388.133-.36.359-.723.714-1.077,1.079a.736.736,0,0,0-.09,1.12c.395.574.794,1.145,1.2,1.709a1.31,1.31,0,0,1,.1,1.429c-.371.816-.728,1.641-1.029,2.484a1.385,1.385,0,0,1-1.194.988q-1.009.161-2.013.354a.707.707,0,0,0-.676.807q-.013.893,0,1.786a.727.727,0,0,0,.681.809c.684.126,1.37.249,2.057.356a1.353,1.353,0,0,1,1.146.983c.3.829.641,1.644,1.012,2.444a1.334,1.334,0,0,1-.093,1.468q-.612.847-1.2,1.71a.736.736,0,0,0,.094,1.119c.384.4.776.784,1.17,1.171a.758.758,0,0,0,1.185.11c.561-.387,1.122-.776,1.674-1.176a1.33,1.33,0,0,1,1.467-.1c.813.376,1.642.722,2.484,1.029a1.33,1.33,0,0,1,.95,1.123c.109.673.23,1.343.35,2.014.1.533.318.729.85.735q.871.01,1.742,0a.71.71,0,0,0,.816-.665c.127-.64.254-1.281.342-1.927a1.492,1.492,0,0,1,1.16-1.344,16.347,16.347,0,0,0,2.241-.934,1.388,1.388,0,0,1,1.582.106c.535.4,1.087.775,1.637,1.153a.742.742,0,0,0,1.151-.105c.414-.407.822-.82,1.232-1.231a.725.725,0,0,0,.088-1.02c-.4-.585-.808-1.171-1.226-1.746a1.352,1.352,0,0,1-.1-1.506,25.052,25.052,0,0,0,1-2.4,1.365,1.365,0,0,1,1.17-1.01c.616-.093,1.228-.217,1.842-.323A3.163,3.163,0,0,1,31.26,129a1.118,1.118,0,0,1,.317,2.2c-.478.116-.974.16-1.45.282a.772.772,0,0,0-.418.343c-.144.248-.176.566-.339.8a1.115,1.115,0,0,0,.159,1.531,3.6,3.6,0,0,1,.994,2.221,2.838,2.838,0,0,1-.739,2.076c-.535.572-1.079,1.14-1.664,1.659a2.855,2.855,0,0,1-3.576.277c-.418-.261-.8-.576-1.226-.826a.767.767,0,0,0-.535-.055c-.263.069-.5.269-.758.317-.723.131-.935.582-1.032,1.258a6.2,6.2,0,0,1-.572,1.846,2.959,2.959,0,0,1-1.94,1.35Z'
                      transform='translate(0 -99.66)'
                      fill='#fff'
                    ></path>
                    <path
                      id='Path_6172'
                      data-name='Path 6172'
                      d='M93.643,199.22a7.579,7.579,0,0,1-.065-15.158,1.165,1.165,0,0,1,1.218,1.059,1.113,1.113,0,0,1-1.076,1.183,5.6,5.6,0,0,0-3.514,1.313,5.3,5.3,0,1,0,8.745,4.4,1.7,1.7,0,0,1,.36-1.176,1.122,1.122,0,0,1,1.206-.259,1.152,1.152,0,0,1,.725,1.093,7.582,7.582,0,0,1-6.388,7.421c-.4.055-.806.082-1.21.121'
                      transform='translate(-76.702 -163.979)'
                      fill='#fff'
                    ></path>
                    <path
                      id='Path_6173'
                      data-name='Path 6173'
                      d='M240.11,85.968a5.406,5.406,0,1,1,5.414-5.386,5.391,5.391,0,0,1-5.414,5.386m-.056-2.268a3.139,3.139,0,1,0-3.074-3.182,3.151,3.151,0,0,0,3.074,3.182'
                      transform='translate(-209.104 -66.957)'
                      fill='#fdb934'
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div>
            <h1 className='heading'>Maintenance in Progress</h1>
            <p id='p1'>{message}</p>
            <p id='p2'>We apologize for any inconvenience caused.</p>
          </div>
        </div>
        <div className='bottom'></div>
      </div>

      <style>{`
        /* Global Reset */
        html,
        body {
          margin: 0;
          padding: 0;
          height: 100%;
          font-family: 'Arial', sans-serif;
        }
      `}</style>
      <style>{`
        .main {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background: linear-gradient(
            to right,
            #1a73e8,
            #0056b3
          ); /* Blue gradient from image */
          color: #ffffff;
          overflow: hidden;
          position: relative;
          box-sizing: border-box;
          padding: 20px;
        }

        /* Background Decorative Shapes (Mimicking the image) */
        .main::before,
        .main::after {
          content: '';
          position: absolute;
          background-color: rgba(255, 255, 255, 0.05);
          border-radius: 50%;
          filter: blur(5px);
          z-index: 1;
        }

        .main::before {
          width: 200px;
          height: 200px;
          top: 10%;
          left: 5%;
        }

        .main::after {
          width: 350px;
          height: 350px;
          bottom: 15%;
          right: 10%;
        }

        .parent {
          display: flex;
          align-items: center;
          gap: 40px;
          z-index: 10;
          max-width: 1200px;
          padding: 20px;
          width: 100%;
          background: rgba(
            255,
            255,
            255,
            0.05
          ); /* Subtle border effect behind content */
          backdrop-filter: blur(5px);
          border-radius: 10px;
          box-sizing: border-box;
        }

        .child1 svg {
          width: 496px;
          height: 481px;
          //   width: 300px;
          //   height: auto;
          min-width: 200px;
        }

        .heading {
          font: normal normal 100 40px/56px Lato;
          margin-bottom: 10px;
          font-weight: 700;
          color: #4dc9ff;
        }

        #p1 {
          font-size: 1.4em;
          margin-bottom: 5px;
          color: #e8e6e6ff; /* Use white, slightly dimmer is handled by opacity on parent or font */
        }

        #p2 {
          font-size: 1.2em;
          color: #cccccc;
        }

        .bottom {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 150px;
          background: linear-gradient(
            to top,
            rgba(0, 0, 0, 0.3),
            transparent
          ); /* Dark shadow effect at the bottom */
          z-index: 5;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .parent {
            flex-direction: column;
            text-align: center;
            gap: 20px;
            padding: 30px 20px;
          }

          .child1 svg {
            width: 250px;
          }

          .heading {
            font-size: 3em;
          }

          #p1 {
            font-size: 1.2em;
          }

          #p2 {
            font-size: 1em;
          }
        }

        @media (max-width: 480px) {
          .child1 svg {
            width: 180px;
          }

          .heading {
            font-size: 2.5em;
          }
        }
      `}</style>
    </>
  );
}
